import { loadLocalSettings, saveLocalSettings } from "../services/storage/localStorageService";
import { normalizeDifficultyMode } from "../game/constants/difficulty";

export const DEFAULT_SETTINGS = {
	sfx: true,
	sound: true,
	sfxVolume: 0.8,
	music: true,
	musicVolume: 0.55,
	effectsIntensity: "normal",
	performanceMode: false,
	vibration: true,
	difficultyMode: "medium",
};

export const normalizeSettings = (settings = {}) => {
	const merged = {
		...DEFAULT_SETTINGS,
		...settings,
	};

	return {
		...merged,
		sfx: settings.sfx ?? settings.sound ?? DEFAULT_SETTINGS.sfx,
		sfxVolume: Number.isFinite(Number(settings.sfxVolume)) ? Number(settings.sfxVolume) : DEFAULT_SETTINGS.sfxVolume,
		musicVolume: Number.isFinite(Number(settings.musicVolume)) ? Number(settings.musicVolume) : DEFAULT_SETTINGS.musicVolume,
		difficultyMode: normalizeDifficultyMode(settings.difficultyMode),
	};
};

export const loadSettings = () => normalizeSettings(loadLocalSettings(DEFAULT_SETTINGS));

export const saveSettings = (settings) => saveLocalSettings(normalizeSettings(settings));
